import { createElementBlock as n, openBlock as o, createElementVNode as e } from "vue";
const d = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(r, l) {
  return o(), n("svg", d, l[0] || (l[0] = [
    e("path", {
      fill: "#EB001B",
      "fill-rule": "evenodd",
      d: "M7.68 19.5c4.242 0 7.68-3.358 7.68-7.5s-3.438-7.5-7.68-7.5S0 7.858 0 12s3.438 7.5 7.68 7.5",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "#00A2E5",
      "fill-rule": "evenodd",
      d: "M16.32 19.5c4.242 0 7.68-3.358 7.68-7.5s-3.438-7.5-7.68-7.5S8.64 7.858 8.64 12s3.438 7.5 7.68 7.5",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "#7375CF",
      "fill-rule": "evenodd",
      d: "M12 5.798C9.972 7.148 8.64 9.422 8.64 12s1.332 4.852 3.36 6.202c2.028-1.35 3.36-3.624 3.36-6.202S14.028 7.148 12 5.798",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c = { render: t };
export {
  c as default,
  t as render
};
//# sourceMappingURL=ic_payment_maestro-CMav17nX.js.map
